import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneConferencePayload } from '@app-store/slices/conferences/oneConference'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneConferencePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.conferences.oneConference

function* oneConferenceSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/event/conference/one/${payload.conferenceId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneConferenceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneConferenceSagaTask)
}

export default oneConferenceSaga
